/**
 * Automatically map a given CSS property name to one with broader support.
 *
 * @example
 * ['blockSize', 'height'],
 * ['insetBlock', ['insetBlockEnd', 'insetBlockStart']],
 */
export const propertyMap = new Map<string, string | string[]>([
  // testing only
  ['monkeyButter', 'bananaBread'],
  // testing only
  ['explique', ['expliqueApres', 'expliqueAvant']],
])
